<div
    class="tw-flex tw-items-center tw-gap-5 tw-h-full tw-p-5 tw-relative tw-justify-evenly"
>
    <button
        (click)="closeDialog()"
        class="tw-absolute tw-right-4 tw-top-4 tw-text-black tw-text-2xl tw-z-10"
        aria-label="Close dialog"
    >
        ✕
    </button>
    <div
        class="tw-flex tw-flex-col tw-gap-2 tw-items-center tw-text-center tw-flex-1 tw-max-w-[270px]"
    >
        <p class="!tw-text-[18px] !tw-font-semibold">
            {{ "LOGIN.USER_DISABLED" | translate }}
        </p>
        <button
            ga-track="track"
            class="tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-text-[16px] tw-bg-[#FFA53C] tw-w-[192px]"
            type="submit"
            (click)="onForgotPassword()"
        >
            {{ "OK" | translate }}
        </button>
    </div>
</div>
